//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'Section',
  props: {
    // opt-in: shows a chevron in the header that collapses the section body
    collapsible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // sections always start expanded; only the chevron collapses them
      open: true
    }
  }
}
